import React, { useEffect } from "react";

export default function InfoDialog({
  open,
  title = "",
  message = "",
  type = "info",
  onClose,
  primaryText = "Close",
  secondaryText = "",      
  onSecondary = null,      
}) {
  useEffect(() => {
    if (!open) return;

    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  const styles = {
    info: {
      badge: "bg-blue-50 text-blue-700 border-blue-200",
      title: "text-gray-900",
    },
    error: {
      badge: "bg-red-50 text-red-700 border-red-200",
      title: "text-gray-900",
    },
    success: {
      badge: "bg-green-50 text-green-700 border-green-200",
      title: "text-gray-900",
    },
  }[type] || {
    badge: "bg-gray-50 text-gray-700 border-gray-200",
    title: "text-gray-900",
  };

  const icon = type === "error" ? "⚠️" : type === "success" ? "✅" : "ℹ️";

  return (
    <div className="fixed inset-0 z-[9999] flex items-center justify-center p-4">
      {/* overlay */}
      <div
        className="absolute inset-0 bg-black/50 backdrop-blur-sm"
        onClick={onClose}
      />

      {/* dialog */}
      <div className="relative w-full max-w-md bg-white rounded-2xl shadow-2xl border border-gray-200 overflow-hidden">
        <div className="p-5 border-b border-gray-200 bg-gradient-to-r from-gray-50 to-white">
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <div className={`inline-flex items-center gap-2 px-3 py-1 rounded-full border text-xs font-medium ${styles.badge}`}>
                <span>{icon}</span>
                <span className="capitalize">{type}</span>
              </div>

              <div className={`mt-3 text-lg font-bold ${styles.title} leading-snug`}>
                {title}
              </div>
            </div>

            <button
              onClick={onClose}
              className="shrink-0 h-9 w-9 rounded-lg border border-gray-200 hover:bg-gray-50 text-gray-600 flex items-center justify-center"
              aria-label="Close"
              type="button"
            >
              ×
            </button>
          </div>
        </div>

        <div className="p-5">
          <div className="text-sm text-gray-700 whitespace-pre-line">
            {message}
          </div>
        </div>

       <div className="p-5 pt-0 flex justify-end gap-2">
        {secondaryText && onSecondary ? (
            <button
            type="button"
            onClick={onSecondary}
            className="px-4 py-2 rounded-xl border border-gray-300 bg-white text-gray-800 hover:bg-gray-50 transition"
            >
            {secondaryText}
            </button>
        ) : null}

        <button
            type="button"
            onClick={onClose}
            className="px-4 py-2 rounded-xl bg-gray-900 text-white hover:bg-black transition"
        >
            {primaryText}
        </button>
        </div>
      </div>
    </div>
  );
}